import { EmptyData, NavMenuError } from 'shared/ui';
import { SectionMenu } from 'shared/ui/section-menu';
import { COUNTRY_ROUTES } from 'shared/consts/routes/country';

import { SECTION } from 'entities/navigation';
import { useGetCountriesQuery } from 'entities/country';
import { AddButton } from './add-button';

const { label, path } = SECTION['banks'];

export function ConnectedCountriesMenu() {
  const { data, isFetching, error } = useGetCountriesQuery();

  if (data && data.statusCode !== 0) {
    return <NavMenuError text={data.statusDescription} />;
  }

  if (error) {
    return <NavMenuError />;
  }

  if (!isFetching && !data) {
    return <EmptyData />;
  }

  const items = data?.countries || [];

  return (
    <SectionMenu
      loading={isFetching}
      items={items}
      menuKey={path}
      absolutePath={COUNTRY_ROUTES.COUNTRIES}
      label={label}
      addButton={<AddButton />}
    />
  );
}
